export default "__VITE_ASSET__b1813a4d__"